import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import Meta from 'react-helmet'
import { Avatar, AppBar, Drawer, Divider, MenuItem } from 'material-ui'
import IconButton from 'material-ui/IconButton'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu'
import List from 'material-ui/List/List'
import ListItem from 'material-ui/List/ListItem'
import { deepOrange300, purple500 } from 'material-ui/styles/colors'
import CommonLoader from '../../components/CommonLoader/CommonLoader'

import {
  getUser,
  logout,
  getReasonsMap,
  getPaymentStatusMap,
  setDefaultState,
  getCaseStatusMap
} from '../../actions/login'
import {
  setStatusOnlineOffline,
  getOnlineStatus
} from '../../actions/dashboard'

const style = {
  avatarStyle: { margin: 5 },
  drawerStyle: { backgroundColor: '#ccc' },
  btnStyle: { marginTop: '6px' }
}

// Import can't be in conditional so use require.
if (process.env.WEBPACK) {
  require('./Header.css') // eslint-disable-line global-require
}

const mapStateToProps = state => {
  return {
    userInfo: state.userInfo,
    isRcmAdmin: state.isRcmAdmin,
    isLoggedOut: state.isLoggedOut,
    hasLoginFailed: state.hasLoginFailed,
    isSalesRoleOnly: state.isSalesRoleOnly,
    head: state.head,
    caseReasonsMap: state.caseReasonsMap,
    caseStatusMap: state.caseStatusMap,
    paymentStatusMap: state.paymentStatusMap,
    isStatusUpdated: state.isStatusUpdated,
    isStatusOnline: state.isStatusOnline
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getUser: bindActionCreators(getUser, dispatch),
    getReasonsMap: bindActionCreators(getReasonsMap, dispatch),
    getCaseStatusMap: bindActionCreators(getCaseStatusMap, dispatch),
    getPaymentStatusMap: bindActionCreators(getPaymentStatusMap, dispatch),
    logout: bindActionCreators(logout, dispatch),
    setStatusOnlineOffline: bindActionCreators(
      setStatusOnlineOffline,
      dispatch
    ),
    getOnlineStatus: bindActionCreators(getOnlineStatus, dispatch),
    setDefaultState: bindActionCreators(setDefaultState, dispatch),
    dispatch
  }
}

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      showLoader: false
    }
    this.handleClose = this.handleClose.bind(this)
    this.handleToggle = this.handleToggle.bind(this)
    this.logoutClicked = this.logoutClicked.bind(this)
    this.toggleLoader = this.toggleLoader.bind(this)
  }

  componentDidMount() {
    const nextProps = this.props
    if (
      nextProps.location.pathname !== '/' &&
      (nextProps.isLoggedOut || nextProps.hasLoginFailed)
    ) {
      this.gotoLogin()
      return
    }
    if (
      nextProps.userInfo &&
      !nextProps.isStatusUpdated &&
      !this.isStatusUpdated
    ) {
      // this.props.getOnlineStatus(nextProps.isSalesRoleOnly);
      if (!Object.keys(nextProps.caseReasonsMap).length) {
        this.props.getReasonsMap()
      }
      if (!Object.keys(nextProps.caseStatusMap).length) {
        this.props.getCaseStatusMap()
      }
      if (!Object.keys(nextProps.paymentStatusMap).length) {
        this.props.getPaymentStatusMap()
      }
      this.isStatusUpdated = true
    }
  }

  componentWillReceiveProps(nextProps) {
    const pathname = this.props.location.pathname,
      isOrderDetailRoute = pathname.indexOf('/detail/') === 0,
      isUnauthorisedRoute = pathname === '/unauthorised-access',
      isIndexRoute = pathname === '/'
    if (!isIndexRoute && (nextProps.isLoggedOut || nextProps.hasLoginFailed)) {
      this.gotoLogin()
    }
    /* if(nextProps.isSalesRoleOnly && !(isOrderDetailRoute || isIndexRoute) && !isUnauthorisedRoute){
      this.props.router.replace('/unauthorised-access');
      return;
    }
    if (nextProps.isStatusOnline && !isIndexRoute && !isOrderDetailRoute) {
      this.props.router.replace('/detail/pullOrder');
      return;
    }*/
    if (nextProps.userInfo && isUnauthorisedRoute) {
      return
    }
    if (
      nextProps.userInfo &&
      !nextProps.isStatusUpdated &&
      !this.isStatusUpdated
    ) {
      // this.props.getOnlineStatus(nextProps.isSalesRoleOnly);
      if (!Object.keys(nextProps.caseReasonsMap).length) {
        this.props.getReasonsMap()
      }
      if (!Object.keys(nextProps.caseStatusMap).length) {
        this.props.getCaseStatusMap()
      }
      if (!Object.keys(nextProps.paymentStatusMap).length) {
        this.props.getPaymentStatusMap()
      }
      this.isStatusUpdated = true
    }
  }

  setUserOffline = () => {
    this.props.setStatusOnlineOffline(0)
  }

  gotoLogin = () => {
    this.props
    this.props.router.push(
      `/?redirectTo=${encodeURIComponent(this.props.location.pathname + this.props.location.search)}`
    )
  }

  toggleLoader = showLoader => {
    this.setState({
      showLoader
    })
  }

  logoutClicked = () => {
    const { showLoader } = this.state
    if (!showLoader) {
      this.toggleLoader(true)
      this.props.logout(this.toggleLoader)
    }
  }

  static getUserInfo(props) {
    return props.userInfo ? props.userInfo : null
  }

  static getMeta(headObj) {
    return {
      title: headObj.title || 'Unified RCM',
      link: [
        {
          rel: 'stylesheet',
          href: 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css',
          integrity:
            'sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u',
          crossorigin: 'anonymous'
        }
      ],
      meta: [
        {
          charset: 'utf-8'
        },
        {
          name: 'description',
          content:
            headObj.description || 'This is a unified application for RCM!'
        }
      ]
    }
  }

  handleToggle() {
    this.setState({ open: !this.state.open })
  }

  handleClose() {
    this.setState({ open: false })
  }

  render() {
    const userInfo = Header.getUserInfo(this.props)
    const { isStatusOnline, isRcmAdmin } = this.props
    const { showLoader } = this.state
    const head = Header.getMeta({
      title: this.props.title,
      description: this.props.description
    })
    const isMenuIconHide = isStatusOnline || !userInfo
    const { roles = [] } = userInfo || {}
    const isRcmPaymentTransfer = roles.includes('RCM_PAYMENT_TRANSFER')
    const isSuperAdmin = roles.includes('RCM_USER_MANAGEMENT')
    return (
      <div>
        <Meta
          title={head.title}
          description={head.description}
          link={head.link}
          meta={head.meta}
        />
        <AppBar
          title='Unified RCM'
          iconElementLeft={
            isMenuIconHide ? (
              <EmptySpan />
            ) : (
              <IconButton>
                <NavigationMenu onClick={this.handleToggle} />
              </IconButton>
            )
          }
        />
        {userInfo && (
          <Drawer
            docked={false}
            width={200}
            open={this.state.open}
            onRequestChange={open => this.setState({ open })}
            style={style.drawerStyle}
          >
            <List>
              <ListItem
                leftAvatar={
                  <Avatar
                    color={deepOrange300}
                    backgroundColor={purple500}
                    size={30}
                    style={style.avatarStyle}
                  >
                    {userInfo.firstName ? userInfo.firstName[0] : ''}
                  </Avatar>
                }
              >
                {userInfo.firstName ? userInfo.firstName : ''}
              </ListItem>
            </List>
            <div className='header-nav'>
              <Link to='/broker-dashboard' onlyActiveOnIndex>
                <MenuItem onClick={this.handleClose}>Broker Dashboard</MenuItem>
              </Link>
              <Divider />
              <Link to='/developer-dashboard' onlyActiveOnIndex>
                <MenuItem onClick={this.handleClose}>
                  Developer Dashboard
                </MenuItem>
              </Link>
              <Divider />
              <Link to='/makaan-dashboard' onlyActiveOnIndex>
                <MenuItem onClick={this.handleClose}>Makaan Dashboard</MenuItem>
              </Link>
              <Divider />
              <Link to='/owner-dashboard' onlyActiveOnIndex>
                <MenuItem onClick={this.handleClose}>Owner Dashboard</MenuItem>
              </Link>
              <Divider />
              <Link to='/tbu-dashboard' onlyActiveOnIndex>
                <MenuItem onClick={this.handleClose}>TBU Dashboard</MenuItem>
              </Link>
              <Divider />
              <Link to='/uploadcsv' onlyActiveOnIndex>
                <MenuItem onClick={this.handleClose}>Upload CSV</MenuItem>
              </Link>
              <Divider />
              <Link to='/drop-opportunity' onlyActiveOnIndex>
                <MenuItem onClick={this.handleClose}>Drop Opportunity</MenuItem>
              </Link>
              {isRcmPaymentTransfer && (
                <React.Fragment>
                  {' '}
                  <Divider />
                  <Link to='/transfer-wallet' onlyActiveOnIndex>
                    <MenuItem onClick={this.handleClose}>
                      Transfer Wallet
                    </MenuItem>
                  </Link>
                </React.Fragment>
              )}
              <Divider />
              <Link to='/search' onlyActiveOnIndex>
                <MenuItem onClick={this.handleClose}>Search</MenuItem>
              </Link>
              {isSuperAdmin && (
                <React.Fragment>
                  <Divider />
                  <Link to='/user-management' onlyActiveOnIndex>
                    <MenuItem onClick={this.handleClose}>
                      User Management
                    </MenuItem>
                  </Link>
                </React.Fragment>
              )}
              {userInfo && isRcmAdmin && (
                <React.Fragment>
                  <Divider />
                  <Link to='/invoice-month' onlyActiveOnIndex>
                    <MenuItem onClick={this.handleClose}>
                      Invoice Month
                    </MenuItem>
                  </Link>
                </React.Fragment>
              )}
              <Divider />
              <MenuItem onClick={this.logoutClicked}>
                <div>Logout</div>
                {showLoader && (
                  <CommonLoader
                    size={35}
                    propStyle={{ margin: '-40px 0 0 65px' }}
                  />
                )}
              </MenuItem>
            </div>
          </Drawer>
        )}
      </div>
    )
  }
}

Header.propTypes = {
  title: PropTypes.string,
  logout: PropTypes.func,
  getUser: PropTypes.func,
  userInfo: PropTypes.object,
  hasLoginFailed: PropTypes.bool,
  description: PropTypes.string
}

class EmptySpan extends Component {
  render() {
    return <span style={{ display: 'none' }} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)



/** WEBPACK FOOTER **
 ** ./src/components/Header/Header.js
 **/